export const TASK_CONSTANTS = {
  MESSAGES: {
    NO_MORE: "Solo puedes agregar un formulario por tarea individual",
    INCOMPLETE: "Información incompleta, no puedes guardar"
  },
  BUTTONS: {
    CREATE_BTN: "Crear tarea",
    SAVE_BTN: "Guardar tarea",
    CANCEL_BTN: "Cancelar tarea"
  },
  LABELS: {
    TITLE: "Configuración Individual de Tareas",
    TASKDATA: "Información de la tarea",
    FORM: "Formulario",
    NOTIFICATIONS: "Notificaciones",
    NAME: "Descripción tarea",
    RESPONSIBLE: "Responsable",
    RELATED: "Relacionado",
    SELECT_RESPONSIBLE: "Seleccione Responsable:",
    RADIO_PATIENT: "Paciente",
    RADIO_ADMINISTRATOR: "Administrativo"
  },
  TASK_SNACKBAR: {
    ERROR_DISABLING: "Ocurrió un error al intentar deshabilitar la tarea",
    TASK_DELETED: "La tarea ha sido eliminada correctamente",
    REQUEST_FAILED: "Ha ocurrido un error, intente más tarde.",
    NO_RESPONSIBLE:
      "Debe seleccionar un responsable para agregar los formularios"
  },
  STATE: {
    PENDING: "Pendiente"
  },
  EVENTS: {
    SAVED: "taskSaved",
    CANCEL: "cancelAddTask",
    DELETE: "deleteTask",
    ASSIGN: "assignedUser"
  },
  TASK_MODAL: {
    TITLE: "Eliminar tarea",
    MESSAGE: "Ingrese la razón por la cual va a deshabilitar la tarea:"
  },
  MESSAGES_DIFFERENCES: {
    TEXT_1: "Solo se puedieron seleccionar",
    TEXT_2: "pacientes de los",
    TEXT_3: "usuarios seleccionados"
  }
};

export const TASK_STATES = {
  PENDING: "Pendiente",
  COMPLETED: "Completada",
  CANCELED: "Cancelada"
};

export const TASK_ACCESS = {
  GET: "consultar tareas",
  POST: "crear tareas",
  PUT: "modificar tareas",
  DELETE: "eliminar tareas"
};

export const VALUES_RESPONSIBLES = {
  PATIENT: "paciente",
  ADMINISTRATOR: "administrativo",
  USER: "user"
};

export const ADMIN_DEPENDENCY = "Administradores";
